export const fakeAccount = {
  id: "624c0513-3c34-4e7f-a678-066e2bb26c0a",
  crmid: "00000000-0000-0000-0000-000000000000",
  clientID: "100000",
  associateID: "E00000000",
  isOIC: false,
  nif: "100000000",
  name: "NOME REDUZIDO DO CLIENTE 000016037",
  iban: "PT50000000000000000000000",
  mymEmail: "joao.maria@teste.com",
  mymTelephone: "911111111",
  email: "joao.maria@teste.com",
  telephone: "911111111",
  address: "MORADA NUM. 001. DO CLIENTE  00000000.",
  postalCode: "1700-115",
  locality: "LISBOA",
  mymLocality: null,
  mymAddress: null,
  mymPostalCode: null,
  age: 26,
  birthDate: "1998-11-12T00:00:00",
  status: "ATIVO",
  stateCode: "S",
  statusDate: "2026-07-22T13:51:28.417",
  associateState: "ATIVO               ",
  hasQuotas: false,
  acceptedGeneralTerms: true,
  acceptedGeneralTermsDate: "2026-02-24T20:14:09.237",
  acceptedBenefitTerms: false,
  acceptedBenefitTermsDate: null,
  primaryBranchCode: "283",
  createdAt: "2026-02-24T20:14:09.237",
  updatedAt: "2026-02-24T20:14:09.237",
  associateAdmissionDate: "1969-03-01T00:00:00",
  generalTermsVersion: "2",
};
